import { baseApi } from "../baseApi";

const PAYMENT_BASE_URL = "/payments";

export const paymentApi = baseApi.injectEndpoints({
  tagTypes: ["PaymentQR"],

  endpoints: (build) => ({
    generateNCHLPaymentQR: build.mutation({
      query: (body) => ({
        url: `${PAYMENT_BASE_URL}/qr/nchl`,
        method: "POST",
        body,
      }),
    }),

    generateFonepayPaymentQR: build.mutation({
      query: (body) => ({
        url: `${PAYMENT_BASE_URL}/qr/fonepay`,
        method: "POST",
        body,
      }),
    }),

    checkNCHLPaymentStatus: build.mutation({
      query: (body) => ({
        url: `${PAYMENT_BASE_URL}/status/nchl`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGenerateNCHLPaymentQRMutation,
  useGenerateFonepayPaymentQRMutation,
  useCheckNCHLPaymentStatusMutation,
} = paymentApi;
